<template>
    <div class="bg-growth rounded-full text-white p-2 fixed top-5 px-6 left-1/2 z-40" v-if="saved">{{ $t('saved') }}</div>
    
    <div style="height: 80vh">
        <h1 class="text-xl font-bold mb-3">Batch Models Form</h1>
        <div v-for="(model, index) in modelsData" :key="index" class="flex gap-1 my-1">
            <MazSelect
                v-model="model.platform" 
                :options="platforms.map(platform => ({ value: platform.id, label: platform.name }))" 
                :label="$t('platform')" 
                :placeholder="$t('platform')" 
                :clearable="true"
            />
            <MazInput 
                v-model="model.free.name"
                :label="$t('stage_name')"
            />
            <MazInput
                v-model="model.free.email"
                :label="$t('reg_form.email')"
            />
            <MazInput
                v-model="model.free.password"
                :label="$t('reg_form.password')"
                type="password"
            />
            <MazSelect v-if="groups && groups.length>1"
                v-model="model.group_id"
                :options="[{ id: null, name: $t('all_groups') }, ...groups]"
                :label="$t('group')"
                optionValueKey="id"
                optionLabelKey="name"
                option-input-value-key="name"
            />
            <MazSelect v-show="groups && groups.length>1 && model.group_id && getTeamOptions(model.group_id).length > 0"
                v-model="model.team_id"
                :options="[{ id: null, name: $t('all_teams') }, ...getTeamOptions(model.group_id)]"
                :label="$t('team')"
                optionValueKey="id"
                optionLabelKey="name"
                option-input-value-key="name"
                @change="clearTeamId(model)"
            />
            <MazSelect v-if="countryList && countryList.length>0"
                :label="$t('pick_country')"
                v-model="model.countryCode"
                :options="countryList"
                optionValueKey="id"
                optionLabelKey="name"
                option-input-value-key="name"
            />
            <MazSelect 
                class=""
                :label="$t('commission')"
                v-model="model.commission_type"
                :options="[{value:'%',label:'%'}, {value:'$',label:'$'}]"
            />
            <MazInput 
                v-model="model.commission"
                :label="$t('commission')"
                type="number"
            />
        </div>
        <button @click="addModel" class="mt-2 p-1.5 px-3 font-bold bg-growth text-black rounded-full text-lg">
            <font-awesome-icon icon="fas fa-plus"/>
        </button>
        <button @click="addMultipleModels" class="bg-growth text-black rounded absolute right-6 mt-5 p-2 px-3 text-buttonText dark:text-black text-center font-semibold whitespace-nowrap">
            <font-awesome-icon icon="fas fa-floppy-disk" class="mr-1"/> {{ $t('save') }}
        </button>
    </div>
</template>

<script>
import { get_platforms, get_groups, get_list_data, save_model } from '@/api/api.js';
export default {
    name: 'BatchModelsForm',
    emits: ['close'],
    data() {
        return {
            platforms: [],
            modelsData: [
                {
                    platform: null,
                    free: {name: null, email:null, password:null},
                    group_id: null,
                    selectedTeams: [],
                    team_id: null,
                    groupName: null,
                    countryCode: null,
                    commission_type: null,
                    commission: null
                }
            ],
            groups: [],
            countryList:null,
            saved: false,
        };
    },
    methods: {
        addModel() {
            this.modelsData.push({
                platform: null,
                free: {name: null, email:null, password:null},
                group_id: null,
                selectedTeams: [],
                team_id: null,
                groupName: null,
                countryCode: null,
                commission_type: null,
                commission: null
            });
        },
        validateModelsDataArray() {
            //return back the new object by looping through the modelsData array and checking if all fields are filled
            return this.modelsData.filter((model) => {
                return model.platform && model.free.name && model.free.email && model.free.password;
            });
        },
        async addMultipleModels() {
            const validatedModelsData = this.validateModelsDataArray();
            console.log("validated:", validatedModelsData);
            //go through each model, validate and save
            if (validatedModelsData.length === 0) {
                alert("Please fill in at least the platform, name, email and password fields for each model.");
                return;
            }
            let saving_log = null;
            for (let i = 0; i < this.modelsData.length; i++) {
                this.saved = true;
                let saving_result = await save_model(this.$cookies.get('userToken'),this.$cookies.get('c_id'),this.modelsData[i]);
                if (saving_result) {
                    if (saving_log) {
                        saving_log += "\n" + saving_result;
                    } else {
                        saving_log = saving_result;
                    }
                }
            }
            setTimeout(() => {this.saved = false;}, 500);
            setTimeout(() => this.$emit('close'), 500)
        },
        getTeamOptions(groupId) {
            const group = this.groups.find(group => group.id === groupId);
            return group ? group.children || [] : [];
        },
        clearTeamId(model) {
            console.log("clearing team id");
            model.team_id = null;
        }
    },
    async created() {
        this.groups = await get_groups(this.$cookies.get("userToken"),this.$cookies.get('c_id'));
        if (this.groups && this.groups.length) {this.displayForm = true;}
        if (this.groups && this.groups.length == 1) {this.modelData.group_id = this.groups[0].id;}
        this.countryList = await get_list_data(this.$cookies.get('userToken'),this.$cookies.get('c_id'),'getCountryCodes',null,null,null,null,null);

        //run addModel 4 times
        for (let i = 0; i < 4; i++) {
            this.addModel();
        }

        this.platforms = await get_platforms(this.$cookies.get('userToken'),this.$cookies.get('c_id'));
    }
};
</script>